import { IProductDetailModel } from "@types";

export function productObject(product: IProductDetailModel, currency: string) {
  const selectedSku = product.skus.find((s) => s.id === product.default_sku_id);
  const images = [];
  if (selectedSku) {
    for (const iterator of selectedSku.medias || []) {
      images.push(iterator.url);
    }
  }

  return {
    "@context": "https://schema.org/",
    "@type": "Product",
    name: product.name,
    description: product.description,
    image: images,
    brand: {
      "@type": "Brand",
      name: product.brand.name,
    },
    category: {
      "@type": "Category",
      name: product.category.name,
    },
    sku: selectedSku?.name ?? "",
    priceSpecification: {
      "@type": "UnitPriceSpecification",
      price: selectedSku?.price.price,
      priceCurrency: currency,
    },
    //Either "offers", "review", or "aggregateRating" should be specified
    offers: {
      "@type": "Offer",
      price: selectedSku?.price.price,
      priceCurrency: currency,
      availability: "http://schema.org/InStock",
    },
    review: {
      "@context": "http://schema.org",
      "@type": "Review",
      itemReviewed: {
        "@type": "Thing",
        name: product.name,
      },
      reviewRating: {
        "@type": "Rating",
        ratingValue: "5",
        bestRating: "5",
      },
      author: {
        "@type": "Person",
        name: "dabdoob",
      },
    },
  };
}
